(function () {
  const ZUSCHLAG_VARIANT_ID = 15136052183364;

  // verhindert Doppler (z.B. wenn DOM neu gerendert wird)
  let isUpdating = false;

  // verhindert Reload-Schleifen: pro Page-Load maximal 1 Reload aus dieser Logik
  const RELOAD_GUARD_KEY = "kuehl_zuschlag_reload_once";

  async function getCart() {
    const res = await fetch("/cart.js", { headers: { Accept: "application/json" } });
    return await res.json();
  }

  function hasKuehlProp(item) {
    const v = item?.properties?._kuehlversand;
    return v === true || v === "true" || v === 1 || v === "1";
  }

  function hatKuehlprodukt(items) {
    return items.some((item) =>
      item?.product_title?.toLowerCase().includes("kühl") ||
      item?.product_type?.toLowerCase().includes("kühl") ||
      (Array.isArray(item?.product_tags) && item.product_tags.includes("kuehlversand")) ||
      item?.product_description?.toLowerCase().includes("kuehlversand")
    );
  }

  function zuschlagImWarenkorb(items) {
    return items.some((item) => item.variant_id === ZUSCHLAG_VARIANT_ID);
  }

  async function addZuschlag() {
    const res = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: ZUSCHLAG_VARIANT_ID, quantity: 1 }),
    });
    return res.ok;
  }

  async function removeZuschlag() {
    const res = await fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: ZUSCHLAG_VARIANT_ID, quantity: 0 }),
    });
    return res.ok;
  }

  async function updateZuschlag() {
    if (isUpdating) return;
    isUpdating = true;

    try {
      const cart = await getCart();

      const hatKuehl =
        cart.items.some(hasKuehlProp) ||
        hatKuehlprodukt(cart.items);

      const hatZuschlag = zuschlagImWarenkorb(cart.items);

      // kein Änderungsbedarf -> fertig
      if ((hatKuehl && hatZuschlag) || (!hatKuehl && !hatZuschlag)) return;

      let ok = false;
      if (hatKuehl && !hatZuschlag) ok = await addZuschlag();
      if (!hatKuehl && hatZuschlag) ok = await removeZuschlag();

      // Wenn Änderung passiert ist: einmalig reload, aber garantiert nicht in Schleife
      if (ok) {
        if (!sessionStorage.getItem(RELOAD_GUARD_KEY)) {
          sessionStorage.setItem(RELOAD_GUARD_KEY, "1");
          location.reload();
        }
      }
    } finally {
      isUpdating = false;
    }
  }

  if (window.location.pathname === "/cart") {
    document.addEventListener("DOMContentLoaded", updateZuschlag);
  }
})();
